var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-copy",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "currentColor",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    ry: 2,
    rx: 2,
    height: 13,
    width: 13,
    y: 9,
    x: 9
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m5,15l-1,0a2,2 0 0 1 -2,-2l0,-9a2,2 0 0 1 2,-2l9,0a2,2 0 0 1 2,2l0,1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAlt);
export default __webpack_public_path__ + "static/media/copy-alt.25beea8d140bd5f411d204640a07d862.svg";
export { ForwardRef as ReactComponent };